// for Duplication Firewall Rule data for Form, we receive data from registration data table but in Form properties names from inputVariablesSchema
export function firewallRulesSchemaAdapter(rule: any, type: string) {
  const obj: Record<string, any> = {};
  if (type === 'destination') {
    obj.destination = rule.target_ip.split(',');
    obj.source = rule.source_ip.split(',');
  } else {
    obj.destination = rule.target_ip.split(',');
    obj.source = rule.source_ip.split(',');
  }
  obj.sourceApmId = rule.source_apm_id || undefined;
  obj.destinationApmId = rule.target_apm_id || undefined;
  obj.details = rule.comment || undefined;
  obj.port = rule.port_numbers || undefined;
  obj.protocol = rule.protocol || undefined;

  return obj;
}
